<template>
  <div class="w-full">
    <div class="w-full">
      <vs-tabs>
        <vs-tab label="Laporan Presensi Harian" icon-pack="feather" icon="icon-calendar">
          <DailyReport />
        </vs-tab>
        <vs-tab label="Laporan Presensi Per-Petugas" icon-pack="feather" icon="icon-calendar">
          <ByUserReport />
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import DailyReport from "./components/DailyReport";
import ByUserReport from "./components/ByUserReport";

export default {
  components: {
    DailyReport,
    ByUserReport
  },
  data() {
    return {
      loading: false
    };
  },
};
</script>